import React from 'react';
import styles from './TextButton.module.scss';
import Icon from '../Icon/Icon';

interface TextButtonProps {
  id?: string;
  onClick: () => void;
  label: string;
  customStyle?: React.CSSProperties;
  isIcon?: boolean;
  iconName?: string | undefined;
  iconSize?: number;
  themeColor?: string | undefined;
  className?: string;
  isDisabled?: boolean;
  disabledThemeColor?: string | undefined;
}

const TextButton: React.FC<TextButtonProps> = ({
  id,
  onClick,
  label,
  customStyle = {},
  isIcon = false,
  iconName,
  iconSize,
  themeColor,
  className,
  disabledThemeColor,
  isDisabled = false,
}) => {
  return (
    <button
      id={id}
      className={`text_button ${className} ${styles.text_button}`}
      style={customStyle}
      onClick={onClick}
      disabled={isDisabled}
    >
      <div className={styles.btn_inner}>
        {isIcon && (
          <span className={styles.btn_icon}>
            <Icon
              name={iconName}
              size={iconSize}
              className={styles.icon}
              color={isDisabled ? disabledThemeColor : themeColor}
            />
          </span>
        )}
        <span
          className={styles.label}
          style={{ color: isDisabled ? disabledThemeColor : themeColor }}
        >
          {label}
        </span>
      </div>
    </button>
  );
};

export default TextButton;
